import { useCallback } from 'react';
import type { TSetDraft } from '@/creditflowresearch/application/hooks/useDraftState';
import type { IColumnCustomizationEntry } from '@/creditflowresearch/application/BondScreener/Sidebar/useColumnsCustomization';

interface IUseColumnOrderingReturn {
  handleOrderChange: (oldIndex: number, newIndex: number, displayedColumns: IColumnCustomizationEntry[]) => void,
}

const moveColumn = (
  columns: IColumnCustomizationEntry[],
  fromId: string,
  toId: string,
): IColumnCustomizationEntry[] => {
  const result = [...columns];
  const sourceIndex = result.findIndex((col) => col.id === fromId);
  const destinationIndex = result.findIndex((col) => col.id === toId);
  const [detached] = result.splice(sourceIndex, 1);
  result.splice(destinationIndex, 0, detached);
  return result;
};

const useColumnOrdering = (setDraftColumns: TSetDraft<IColumnCustomizationEntry[]>): IUseColumnOrderingReturn => {
  const handleOrderChange = useCallback((
    draggedIndex: number,
    droppedIndex: number,
    displayedColumns: IColumnCustomizationEntry[],
  ): void => {
    const draggedColumn = displayedColumns[draggedIndex];
    const droppedOnColumn = displayedColumns[droppedIndex];

    if (draggedColumn.isLocked || droppedOnColumn.isLocked) return;

    setDraftColumns((prev) => moveColumn(prev, draggedColumn.id, droppedOnColumn.id));
  }, [setDraftColumns]);

  return { handleOrderChange };
};

export default useColumnOrdering;
